<template>
  <v-row>
    <v-dialog v-model="dialog" max-width="500px">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="primary"
          v-bind="attrs"
          class="text-capitalize text-right"
          v-on="on"
        >
          Add staff
        </v-btn>
      </template>
      <v-card>
        <v-card-title>
          <span class="text-h5">Add Staff</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                  label="Name*"
                  v-model="form.name"
                  outlined
                  dense
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  label="Phone Number*"
                  required
                  outlined
                  dense
                  v-model="form.phone"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  label="Email*"
                  required
                  outlined
                  dense
                  v-model="form.email"
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="6">
                <v-text-field
                  outlined
                  :type="showPassword ? 'text' : 'password'"
                  dense
                  @click:append="showPassword = !showPassword"
                  color="primary"
                  :rules="[rules.password, rules.required]"
                  append-icon="mdi-eye"
                  label="Enter Password"
                  v-model="form.password"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialog = false"> Close </v-btn>
          <v-btn color="primary" text @click="create()" :loading="loading">
            Create
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  data: () => ({
    dialog: false,
    form: {
      name: "",
      email: "",
      phone: "",
      password: "",
    },
    showPassword: "",
    loading: false,

    rules: {
      email: (v) => !!(v || "").match(/@/) || "Please enter a valid email",
      length: (len) => (v) =>
        (v || "").length >= len || `Invalid character length, required ${len}`,
      required: (v) => !!v || "This field is required",
      password: (value) =>
        (value && value.length >= 5) || "Minimum length is 5 characters",
    },
  }),
  computed: {
    ...mapGetters(["getUser", "currentUser"]),
  },

  methods: {
    create() {
      this.loading = true;

      fetch("https://receipt.drecsoft.com/api/v1/business/create-store-users", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.currentUser}`,
        },
        body: JSON.stringify({
          name: this.form.name,
          phone: this.form.phone,
          email: this.form.email,
          password: this.form.password,
        }),
      })
        .then((res) => {
          console.log(res);
          this.loading = false;
          this.$router.go();
        })
        .catch((err) => {
          this.loading = false;
          console.log(err);
        });
    },
  },
};
</script>